import { app } from '../../../app';

app.component('companyAdministrators', {
    templateUrl: require('./administrators.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/administrators/administrators.component.js